var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudCheckDarkSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 4.69463C12.4467 2.39464 10.4267 0.667969 8 0.667969C6.07333 0.667969 4.4 1.7613 3.56667 3.3613C1.56 3.57464 0 5.27464 0 7.33463C0 9.5413 1.79333 11.3346 4 11.3346H12.6667C14.5067 11.3346 16 9.8413 16 8.0013C16 6.2413 14.6333 4.81464 12.9 4.69463ZM12.6667 10.0013H4C2.52667 10.0013 1.33333 8.80797 1.33333 7.33463C1.33333 5.96797 2.35333 4.82797 3.70667 4.68797L4.42 4.61464L4.75333 3.9813C5.38667 2.7613 6.62667 2.0013 8 2.0013C9.74667 2.0013 11.2533 3.2413 11.5933 4.95464L11.7933 5.95464L12.8133 6.02797C13.8533 6.09464 14.6667 6.96797 14.6667 8.0013C14.6667 9.1013 13.7667 10.0013 12.6667 10.0013ZM6.66667 7.45464L5.27333 6.0613L4.33333 7.0013L6.66667 9.33463L10.6733 5.32797L9.73333 4.38797L6.66667 7.45464Z",
    fill: "#42495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheckDarkSmallIcon);
export default __webpack_public_path__ + "static/media/CloudCheckDarkSmallIcon.e09cf12f.svg";
export { ForwardRef as ReactComponent };